var StoreAttributeModel = Backbone.Model.extend({
});

module.exports = StoreAttributeModel;